/** Member JWT + cached profile helpers (localStorage persistence). */

import {
  MEMBER_TOKEN_KEYS,
  MEMBER_USER_KEY,
  clearMemberStorage,
} from './memberStorage';

export { MEMBER_TOKEN_KEYS, MEMBER_USER_KEY, clearMemberStorage };

export function getMemberAccessToken() {
  return localStorage.getItem('access_token');
}

export function getMemberRefreshToken() {
  return localStorage.getItem('refresh_token');
}

export function readCachedMemberUser() {
  const raw = localStorage.getItem(MEMBER_USER_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function persistMemberTokens({ access, refresh }) {
  if (access) localStorage.setItem('access_token', access);
  if (refresh) localStorage.setItem('refresh_token', refresh);
}

export function isRequestCancelled(err) {
  return (
    err?.code === 'ERR_CANCELED' ||
    err?.name === 'CanceledError' ||
    err?.message === 'canceled'
  );
}

/** True when the session is invalid (401) or the account was blocked (403). */
export function isAuthFailure(err) {
  if (err?.response?.status === 401) return true;
  const data = err?.response?.data;
  return (
    err?.response?.status === 403 &&
    (data?.code === 'account_blocked' || data?.is_blocked === true)
  );
}

export function isAccountBlockedError(err) {
  const data = err?.response?.data;
  return data?.code === 'account_blocked' || data?.is_blocked === true;
}
